var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-viewer",class:{'has-error': _vm.error}},[(_vm.error)?_c('span',{staticClass:"warning"},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"cols":"30","rows":"10"},domProps:{"value":_vm.json},on:{"input":_vm.parseJson,"blur":_vm.prettify}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ceaaf16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/ui/JsonViewer.vue
// module id = zRZe
// module chunks = 0 1 2